import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ConfirmationService, ConfirmDialogModule, SharedModule } from 'primeng/primeng';
import { LoaderComponent } from './common/loader/loader.component';
import { SearchSuggestionsComponent } from './common/search-suggestions/search-suggestions.component';
import { scrollToErrorDirective } from './directive/scroll-to-error.directive';
import { CalendarTooltipService } from './common/services/calendar-tooltip.service';
import { CalendarTooltipComponent } from './common/calendar-tooltip/calendar-tooltip.component';
import { ToastComponent } from './common/toast/toast.component';
import { TripPlannerService } from './admin/services/trip-planner.service';
import { PhoneMaskDirective } from './common/phone-mask/phone-mask.directive';

@NgModule({
  declarations: [
    LoaderComponent,
    scrollToErrorDirective,
    SearchSuggestionsComponent,
    CalendarTooltipComponent,
    ToastComponent,
    PhoneMaskDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    LoaderComponent,
    SearchSuggestionsComponent,
    CalendarTooltipComponent,
    ToastComponent,
    scrollToErrorDirective,
    ConfirmDialogModule,
    PhoneMaskDirective,
    SharedModule],
  providers: [
    ConfirmationService,
    CalendarTooltipService,
    TripPlannerService
  ]
})
export class AppSharedModule { }



// WEBPACK FOOTER //
// ./src/app/app-shared.module.ts